import { callAuthorizedGraphQLEndpoint } from "../../module/graphQL";

export const doCheckoutGQL = async ({ campaignId, campaignDetailedCosts }) => {
  const query = `
    mutation ($input: CheckoutCartInput!) {
      doCheckout(input: $input) {
        postalCode,
        costType,
        taxAmount,
        taxRate,
        state,
        costPerRow
      }
    }
  `;

  const input = {
    campaignId: parseInt(campaignId),
    campaignDetailedCosts,
  };

  try {
    const response = await callAuthorizedGraphQLEndpoint(query, { input });

    if (response.status === 200) {
      const {
        data: { getCart: cartData },
      } = await response.json();

      return cartData;
    } else {
      throw new Error(`Failed to fetch cart: ${response.status}`);
    }
  } catch (error) {
    console.error("Error fetching cart:", error);
    throw error;
  }
};
